import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Layout } from 'blaze-validator';
import Api from '../../services/ApiService';
import LoadingPage from '../LoadingPage';
import Form from '../form/Form';

class PrintRepairOrder extends PureComponent {
  constructor(props) {
    super(props);

    this.submit = this.submit.bind(this);

    this.layout = [
      {
        type: 'section',
        label: 'Options',
        fields: [
          {
            name: 'invoiceNum__1',
            data: props.repairOrderId,
            hidden: true,
          },
          {
            name: 'documentType__3',
            data: 'R',
            hidden: true,
          },
          {
            col: 6,
            name: 'printer__7',
            label: 'Printer',
            options: [],
          },
          {
            col: 6,
            name: 'emailAddress__8',
            label: 'Email Address',
            options: [],
            helpText: 'Please note: Costs cannot be emailed on parts invoices.',
          },
          {
            name: 'printType__5',
            label: 'Print Type',
            type: 'string',
            required: true,
            noEmptyOption: true,
            options: [
              {
                value: 'C',
                label: 'Customer',
              },
              {
                value: 'W',
                label: 'Warranty',
              },
              {
                value: 'I',
                label: 'Internal',
              },
            ],
          },
        ],
      },
    ];

    this.state = {
      layout: [],
      isReady: false,
      hideSubmit: false,
    };
  }

  componentDidMount() {
    const { repairOrderId } = this.props;

    this.props.setTitle(`Print Repair Order (${repairOrderId})`);
    Api.get('printers/ro', { params: { repairOrderId } }).then(response => {
      const data = _.get(response, 'data');
      const message = _.get(data, 'responses[0].error');
      if (message) {
        this.setState({
          isReady: true,
          hideSubmit: true,
          layout: [
            {
              name: 'message',
              control: 'Paragraph',
              style: 'banner',
              data: message,
            },
          ],
        });
        return;
      }

      const layout = new Layout(this.layout);
      layout.populateLayout(data);

      this.setState({
        isReady: true,
        layout: layout.getLayout(),
      });
    });
  }

  submit(payload) {
    const { repairOrderId } = this.props;
    return Api.post(`print/ro/${repairOrderId}`, payload);
  }

  render() {
    if (!this.state.isReady) {
      return <LoadingPage style={{ padding: '50px' }} />;
    }

    return (
      <Form
        feedback="none"
        onCancel={this.props.close}
        layout={this.state.layout}
        submit={this.submit}
        submitCallback={this.props.close}
        submitAll
        useDirtyWarning={false}
        hideSubmit={this.state.hideSubmit}
      />
    );
  }
}

PrintRepairOrder.propTypes = {
  close: PropTypes.func,
  repairOrderId: PropTypes.string,
  setTitle: PropTypes.func,
};

export default PrintRepairOrder;
